import styled from 'styled-components';
import {useTranslation} from 'react-i18next';
import config from '../../../config';

const Page = styled.div`
  padding-top: 165px;
  @media ${config.layout.wide} {
    padding-top: 177px;
  }
`;

const PageFeatureTitle = styled.div`
  position: relative;

  h2 {
    text-align: center;
    font-size: 50px;
    font-weight: bold;

    @media ${config.layout.wide} {
      font-size: 70px;
    }
  }
`;

export default function NotFoundPage() {
  const {t} = useTranslation();

  return (
      <Page>
        <PageFeatureTitle>
          <h2>{t('notFound.title')}</h2>
        </PageFeatureTitle>
      </Page>
  );
}
